// en, de, fr, pt
export default {
  en: {},
  id: {
    Dashboard: 'Dasbor',
    'Dashboard Analytics': 'Analitik Dasbor',
    Analytics: 'Analitik',
    Vehicle: 'Kendaraan',
    Provisioning: 'Provisioning',
    Proposing: 'Proposing',
    User: 'Pengguna',
    'User Account': 'Akun Pengguna',
    'Menu Configuration': 'Konfigurasi Menu',
    'Role & Permission': 'Peran & Izin',
    'POI (Point of Interest)': 'POI (Point of Interest)',
    'POI Category': 'Kategori POI',
    'POI List': 'Daftar POI',
    Geofence: 'Geofensi',
   "Geofence List": 'Daftar Geofensi',
   "Geofence Category": 'Kategori Geofensi',
    Configuration: 'Konfigurasi',
    Configurations: 'Konfigurasi',
    'Vehicle Mapping': 'Pemetaan Kendaraan',
    'Fleet Group': 'Kelompok Armada',
    Alert: 'Alert',
    'Alert Mapping': 'Pemetaan Alert',
    'Alert History': 'Riwayat Alert',
    Export: 'Ekspor',
    'Vehicle Notifications': 'Notifikasi Kendaraan',
    'View All Notification': 'Lihat Semua Notifikasi',

    'Vehicle Status': 'Status Kendaraan',
    'Total Vehicle': 'Total Kendaraan',
    'Unit In Operation': 'Unit Dalam Operasi',
    'Unit On Operation': 'Unit Dalam Operasi',
    'Moving Vehicle': 'Kendaraan Bergerak',
    'Idle Vehicle': 'Kendaraan Idle',
    'Stop Vehicle': 'Kendaraan Berhenti',
    'Silence Vehicle': 'Kendaraan Tidak Aktif',
    'In Repair Vehicle': 'Kendaraan Dalam Perbaikan',
    'License Plate': 'Plat Nomor',
    'Vehicle Model': 'Model Kendaraan',
    'Vehicle Brand': 'Merek Kendaraan',
    'Vehicle Number': 'Nomor Kendaraan',
    'Vehicle number': 'Nomor rangka',
    'License plate': 'Plat Nomor',
    Filter: 'Filter',

    IMEI: 'IMEI',
    Driver: 'Pengemudi',
    'Driver Name': 'Nama Pengemudi',
    'Driver Phone': 'Telepon Pengemudi',
    Speed: 'Kecepatan',
    'Last Updated': 'Terakhir Diperbarui',
    Address: 'Alamat',
    Urgent: 'Darurat',
    'Accident Event': 'Kejadian Kecelakaan',
    'Main Battery Disconnected Event': 'Kejadian Baterai Utama Terputus',
    'Overstay Engine On Event': 'Kejadian Overstay Mesin Menyala',
    'Overstay Engine Off Event': 'Kejadian Overstay Mesin Mati',
    'Geofence In Event': 'Kejadian Geofence Masuk',
    'Geofence Out Event': 'Kejadian Geofence Keluar',
    'Overstay Precentages': 'Persentase Overstay',
    'Geofence Precentages': 'Persentase Geofence',
    'Temperature Precentages': 'Persentase Suhu',
    'Over Chiller Temperature ': 'Suhu Pendingin Terlalu Panas',
    'Towing detected': 'Derek',
    'Main Battery Low Voltage': 'Setrum Accu tidak Optimal',
    'Total Ritation': 'Total Ritase',

    'Accu High': 'Daya Accu terlalu tinggi',
    'Accu Low': 'Daya Accu terlalu rendah',
    'Accumulator High Voltage': 'Daya Accu terlalu tinggi',
    'Accumulator Low Voltage': 'Daya Accu terlalu rendah',

    Summary: 'Ringkasan',
    'Overspeed Event': 'Kejadian Overspeed',
    'Harsh Break Event': 'Kejadian Rem Keras',
    'Harsh Acceleration Event': 'Kejadian Akselerasi Keras',
    'Towing Detected Event': 'Kejadian Towing Terdeteksi',

    'Total Overspeed Event': 'Total Kejadian Overspeed',
    'Total Harsh Brake Event': 'Total Kejadian Rem Keras',
    'Total Harsh Acceleration Event': 'Total Kejadian Akselerasi Keras',
    'Total Accident Event': 'Total Kejadian Kecelakaan',
    'Total Verified Alert Event': 'Total Kejadian Alert Terverifikasi',
    'Total Unverified Alert Event': 'Total Kejadian Alert Tidak Terverifikasi',
    'Total Not Yet Verified Alert Event':
      'Total Kejadian Alert Belum Terverifikasi',
    'Over Temperature Event': 'Kejadian Suhu Tinggi',
    'Rear Door Open Event': 'Kejadian Pintu Belakang Terbuka',
    'Top 10 Overspeed Fleet Group': 'Top 10 Kelompok Armada Overspeed',
    'Top 10 Harsh Break Fleet Group': 'Top 10 Kelompok Armada Rem Keras',
    'Top 10 Harsh Acceleration Fleet Group':
      'Top 10 Kelompok Armada Akselerasi Keras',
    'Top 10 Accident Fleet Group': 'Top 10 Kelompok Armada Kecelakaan',
    'Top 10 Verified Alert Fleet Group':
      'Top 10 Kelompok Armada Alert Terverifikasi',
    'Top 10 Unverified Alert Fleet Group':
      'Top 10 Kelompok Armada Alert Tidak Terverifikasi',
    'Top 10 Overspeed Vehicle': 'Top 10 Kendaraan Overspeed',
    'Top 10 Harsh Break Vehicle': 'Top 10 Kendaraan Rem Keras',
    'Top 10 Harsh Acceleration Vehicle': 'Top 10 Kendaraan Akselerasi Keras',
    'Top 10 Accident Vehicle': 'Top 10 Kendaraan Kecelakaan',
    'Top 10 Verified Alert Vehicle': 'Top 10 Kendaraan Alert Terverifikasi',
    'Top 10 Unverified Alert Vehicle':
      'Top 10 Kendaraan Alert Tidak Terverifikasi',

    'Vehicle Provisioning': 'Provisioning Kendaraan',
    'Vehicle Proposing': 'Kendaraan Proposing',
    'Add New': 'Tambah Baru',
    'Add Bulk': 'Tambah Massal',
    'Update Bulk': 'Perbarui Massal',
    'Dismantle Bulk': 'Bongkar Massal',
    Year: 'Tahun',
    Brand: 'Merek',

    COUNT: 'JUMLAH',
    VEHICLE: 'KENDARAAN',
    YEAR: 'TAHUN',
    'LICENSE PLATE': 'PLAT NOMOR',
    'FLEET GROUP': 'KELOMPOK ARMADA',
    ALERT: 'KEJADIAN',
    'DRIVER NAME': 'NAMA PENGEMUDI',
    'DRIVER PHONE': 'TELEPON PENGEMUDI',
    SPEED: 'KECEPATAN',
    DURATION: 'DURASI',
    DATE: 'TANGGAL',
    LOCATION: 'LOKASI',
    ACTION: 'AKSI',
    NOTES: 'CATATAN',

    'See Details': 'Lihat detil',
    'See Notes': 'Lihat Catatan',
    'Show Google Maps': 'Lihat google maps',
    'Show Street View': 'Lihat tampilan jalanan',
    'Verification required': 'Wajib tindaklanjuti',
    'Not yet verified': 'Belum ditindaklanjuti',
    'Not Verified': 'Tidak ditindaklanjuti',

    All: 'Semua',
    Verified: 'Terverifikasi',
    Validated: 'Tervalidasi',
    'Not Yet Verified': 'Belum Terverifikasi',

    'Vehicle information': 'Informasi kendaraan',
    'GPS date': 'Tanggal GPS',
    'Fleet group': 'Operating point',
    'License plate': 'Plat Nomor',
    'Vehicle model': 'Tipe kendaraan',
    'Driver name': 'Nama pengemudi',
    Latitude: 'Garis lintang',
    Longitude: 'Garis bujur',
    Location: 'Lokasi',
    'Street view': 'Tampilan jalanan',
    'Vehicle status': 'Status kendaraan',
    'Event name': 'Nama kejadian',
    Speed: 'Kecepatan',
    'Total odometer': 'Total odometer',
    Fuel: 'BBM',
    Direction: 'Arah',
    'Engine temp': 'Suhu mesin',
    'Chiller temp 1': 'Suhu pendingin 1',
    'Chiller temp 2': 'Suhu pendingin 2',
    Humidity: 'Kelembaban',
    RPM: 'RPM',
    'Engine status': 'Status mesin',
    SOS: 'Darurat',
    'Left door': 'Pintu kiri',
    'Right door': 'Pintu kanan',
    'Rear door': 'Pintu belakang',
    Fatigue: 'Kelelahan',
    Overview: 'Gambaran',
    'Live track': 'Aktual perjalanan',
    'Periodic track': 'Riwayat perjalanan',
    'Select start date': 'Pilih tanggal mulai',
    'Select end date': 'Pilih tanggal selesai',
    'Please select date range first':
      'Silahkan pilih rentang tanggal terlebih dahulu',
    Clear: 'Hapus',
    'Download data': 'Unduh data',
    'Start / end point': 'Titik mulai / selesai perjalanan',
    'Way point': 'Titik perjalanan',
    'Event point': 'Titik kejadian',
    Ignition: 'Kontak mesin',
    'Accu voltage': 'Tegangan aki',

    'Not Verified': 'Tidak Terverifikasi',
    'Not Validated': 'Tidak Tervalidasi',
    'Verified By': 'Terverifikasi Oleh',
    'Validation By': 'Tervalidasi Oleh',
    Verification: 'Verifikasi',
    Validation: 'Validasi',
    Required: 'Dibutuhkan',
    Filter: 'Filter',

    'Code (shortname)': 'Kode (nama pendek)',
    Level: 'Level',
    Parent: 'Induk',
    'Is fuel consumption': 'Apakah konsumsi BBM ? ',
    'Overspeed threshold (km/h)': 'Parameter kecepatan berlebih (km/jam)',
    'Overstay engine on threshold (minutes)':
      'Parameter kendaran idle terlalu lama (menit)',
    'Overstay engine off threshold (minutes)':
      'Parameter kendaran berhenti terlalu lama (menit)',
    'Phone numbers': 'Nomor telepon',
    'True ': 'Ya',
    FALSE: 'Tidak',

    'User Management': 'Manajemen Pengguna',
    User: 'Pengguna',
    Role: 'Peran',
    NAME: 'NAMA',
    ROLE: 'PERAN',
    'LAST LOGIN': 'TERAKHIR LOGIN',

    'Phone number': 'Nomor telepon',
    'New password': 'Kata sandi baru',
    Submit: 'Kirim',
    Cancel: 'Batal',
    'Menu configuration': 'Konfigurasi menu',
    Menu: 'Menu',
    Icon: 'Ikon',
    'Menu link': 'Tautan menu',
    Parent: 'Induk',
    'Role & permission': 'Peran dan izin',
    Read: 'Lihat',
    Create: 'Tambah',
    Update: 'Perbarui',
    Edit: 'Ubah',
    Delete: 'Hapus',

    Geofence: 'Geofensi',
    'Master Geofence': 'Master Area',
    'Geofence Mapping': 'Mapping Area',
    'Geofence Mapping Detail': 'Detail Mapping Area',
    'Geofence Name': 'Nama Area',
    'Geofence Type': 'Tipe Area',
    'Geofence Categories': 'Kategori Area',
    'GEOFENCE NAME': 'NAMA AREA',
    'GEOFENCE CATEGORY': 'KATEGORI AREA',
    TYPE:'TIPE',
    'Red zone': 'Zona merah',
    minutes: 'menit',

    'Alert In Zone': 'Alert di dalam zona',
    'Alert Out Zone': 'Alert di luar zona',
    'Geofence DC Active': 'Geofence DC Aktif',
    'Overspeed Threshold': 'Parameter kecepatan berlebih',
    'Overstay Engine On Threshold': 'Parameter kendaran idle terlalu lama',
    'Overstay Engine Off Threshold': 'Parameter kendaran berhenti terlalu lama',
    'Paired Vehicle': 'Kendaraan yang dipasangkan',

    'VEHICLE BRAND': 'MERK KENDARAAN',
    'VEHICLE MODEL': 'MODEL KENDARAAN',
    'Brand name': 'Nama merk',
    Status: 'Status',
    Action: 'Tindaklanjut',
    ACTION: 'TINDAKLANJUT',
    Active: '	Aktif',
    Edit: 'Edit',
    'Vehicle model': 'Tipe kendaraan',
    Brand: 'Merk',
    'Model name': 'Nama tipe',
    'Add new model': 'Tambah tipe baru',
    'Add new': 'Tambah baru',
    'Update data': 'Edit data',

    'Vehicle Information': 'Informasi kendaraan',
    'Vehicle Status': 'Status kendaraan',
    'Event Name': 'Nama Event',
    Speed: 'Kecepatan',
    Fuel: 'BBM',
    Direction: 'Arah',
    'Internal Battery': 'Baterai internal',
    'External Battery': 'Baterai eksternal',
    'Engine Temp': 'Suhu mesin',
    'Chiller Temp 1': 'Suhu pendingin 1',
    'Chiller Temp 2': 'Suhu pendingin 2',
    Humidity: 'Kelembaban',
    'Battery Level (eye sensor)': 'Tingkat baterai (sensor mata)',
    'Engine Status': 'Status mesin',
    'Left Door': 'Pintu kiri',
    'Right Door': 'Pintu kanan',
    'Rear Door': 'Pintu belakang',
    Fatigue: 'Kelelahan',

    'Over Temperature': 'Temperatur Berlebih',
    'Harsh Cornering': 'Menikung dengan Keras',
    'Geofence Out': 'Geofence Keluar',
    'Poi In': 'POI Masuk',
    'Harsh Acceleration': 'Akselerasi Keras',
    'Main Battery Disconnected (Power Loss)':
      'Baterai Utama Terputus (Kehilangan Daya)',
    'Driver Change': 'Pergantian Pengemudi',
    'Harsh Brake': 'Rem Keras',
    'Over Chiller Temperature': 'Temperatur Pendingin Berlebih',
    'Over Speed': 'Kecepatan Berlebih',
    'Accident Event': 'Kejadian Kecelakaan',
    'Main Battery Reconnected': 'Baterai Utama Tersambung Kembali',
    'Panic Button Off': 'Tombol Panik Mati',
    'Period Tracking': 'Pelacakan Periode',
    'Over Stay Engine Off': 'Kendaraan OFF Berhenti Terlalu Lama',
    'Over Stay Engine On': 'Kendaraan ON Berhenti Terlalu Lama',
    'Panic Button On': 'Tombol Panik Hidup',
    'Fatigue Off': 'Kelelahan Mati',
    'Engine Off': 'Mesin Mati',
    'Towing Detected': 'Penarikan Terdeteksi',
    'Poi Out': 'POI Keluar',
    'Engine On': 'Mesin Hidup',
    'Jamming Detection': 'Deteksi Jamming',
    'Under Chiller Temperature': 'Di Bawah Suhu Chiller',
    'Door Rear Open': 'Pintu Belakang Terbuka',
    'Door Rear Close': 'Pintu Belakang Tertutup',
    'Fatigue On': 'Kelelahan Aktif',
    'Door Left Open': 'Pintu Kiri Terbuka',
    'Main Battery Low Voltage': 'Baterai Utama Tegangan Rendah',
    'Door Left Close': 'Pintu Kiri Tertutup',
    'Over Rpm': 'Lebih dari Rpm',
    'Backup Battery Failure': 'Baterai Cadangan Gagal',
    'Red Zone': 'Zona Merah',
    'Door Right Open': 'Pintu Kanan Terbuka',
    'Geofence In': 'Geofence Masuk',
    'Door Right Close': 'Pintu Kanan Tertutup',
    'Backup Battery Low Voltage': 'Baterai Cadangan Tegangan Rendah',
    "Driver's not recognized":"Pengemudi tidak dikenali",
  },
}
